/*
 * @Author: Wang Wenmao
 * @Date: 2023-09-27 13:50:38
 * @LastEditors: Wang Wenmao
 * @LastEditTime: 2024-01-04 13:35:33
 * @Description: 添加参数弹窗
 */
import React from 'react';
import { Modal, Button, Form, Input, Select, Table, Row, Col, message } from 'antd';
import { services } from '@comall-backend-builder/core';
import { errorHandle } from '../../services';

const { Option } = Select;

const { api } = services;

const getHashPathParameter = () => {
    const hash = window.location.hash;
    const segments = hash.split('/');
    const param = segments[3];
    return param;
};

const columns: any = [
    {
        title: '属性编码',
        dataIndex: 'code',
        key: 'code',
    },
    {
        title: '属性名称',
        dataIndex: 'name',
        key: 'name',
    },
    {
        title: '字典编码',
        dataIndex: 'sapCode',
        key: 'sapCode',
    },
    {
        title: '属性类型',
        dataIndex: 'type',
        key: 'type',
    },
];

// 默认表单数据
const defaultForm = { name: '', code: '', type: undefined };

interface IProps {
    visible: boolean;
    selectedCodes: any[];
    onClose: (flag: boolean) => void;
}

interface IState {
    dataSource: any[];
    form: { name: string; code: string; type: string | undefined };
    selectedRowKeys: any[];
    accumulateData: any[];
    loading: boolean;
    page: number;
    per_page: number;
    total: number;
}

class Dialog extends React.Component<IProps, IState> {
    state = {
        dataSource: [],
        accumulateData: [],
        form: defaultForm,
        selectedRowKeys: [],
        loading: false,
        page: 1,
        per_page: 10,
        total: 0,
    };

    componentDidUpdate(prevProps: Readonly<IProps>): void {
        if (prevProps.visible !== this.props.visible && this.props.visible) {
            this.getAttrList();
        }
    }

    // 商品属性参数列表
    getAttrList = () => {
        const { form, page, per_page, dataSource, selectedRowKeys, accumulateData } = this.state;
        const { selectedCodes } = this.props;

        const apiPath = `/products/getAttrList?page=${page}&per_page=${per_page}&attr_name=${
            form.name
        }&attr_code=${form.code}&attr_type=${form.type || ''}`;
        this.setState({ loading: true }, () =>
            api
                .get({}, { apiPath })
                .then((res: any) => {
                    this.setState({
                        dataSource: res.result,
                        selectedRowKeys: [...selectedCodes, ...selectedRowKeys],
                        total: res.totalNum,
                        accumulateData: [...accumulateData, ...res.result].reduce(
                            (acc, current) => {
                                const x = acc.find((item: any) => item.id === current.id);
                                return !x ? acc.concat([current]) : acc;
                            },
                            []
                        ),
                    });
                })
                .catch(errorHandle)
                .finally(() => this.setState({ loading: false }))
        );
    };

    // 批量插入属性配置
    addAttrList = () => {
        const params = getHashPathParameter();
        if (!params) return;
        const { selectedRowKeys, accumulateData } = this.state as any;
        const data = [...(new Set(selectedRowKeys) as any)];
        const ids = accumulateData
            .filter((item: any) => data.includes(item.code))
            .map((el: any) => el.id);

        const apiPath = `/products/addAttrList/${params}`;
        return new Promise((resolve) => {
            api.post(ids, { apiPath })
                .then(() => {
                    message.success('添加成功');
                    resolve(true);
                })
                .catch(errorHandle);
        });
    };

    // 点击弹窗按钮
    handleClickModalBtn = async (type: string) => {
        const { selectedRowKeys } = this.state;
        const { onClose } = this.props;
        let flag = false;
        if (type === '0' && selectedRowKeys.length) {
            const res = await this.addAttrList();
            flag = res as boolean;
        }

        this.setState(
            { form: defaultForm, selectedRowKeys: [], page: 1, per_page: 10, total: 0 },
            () => onClose(flag)
        );
    };

    // 点击操作按钮
    handleClickOps = (type: string) => {
        if (type === '1') {
            this.setState({ form: defaultForm, page: 1 }, this.getAttrList);
        } else {
            this.getAttrList();
        }
    };

    // 表单数据变化
    handleChangeFormItem = (type: string, value: string | number) => {
        const { form } = this.state;
        this.setState({ form: { ...form, [type]: value } });
    };

    render() {
        const { visible, selectedCodes } = this.props;
        const { form, dataSource, selectedRowKeys, loading, page, per_page, total } = this.state;

        const tableProps: any = {
            rowKey: 'code',
            style: { marginTop: 20 },
            columns,
            dataSource,
            loading,
            rowSelection: {
                type: 'checkbox',
                selectedRowKeys,
                getCheckboxProps: (record: any) => ({
                    disabled: selectedCodes.includes(record.code),
                }),
                onChange: (_selectedRowKeys: any, _selectedRows: any) =>
                    this.setState({ selectedRowKeys: _selectedRowKeys }),
            },
            pagination: {
                current: page,
                pageSize: per_page,
                total,
                showSizeChanger: true,
                pageSizeOptions: ['10', '15', '20'],
                showTotal: (_total: number) => `共 ${_total} 条记录`,
                onChange: (page: number, _pageSize: number) =>
                    this.setState({ page }, this.getAttrList),
                onShowSizeChange: (current: number, size: number) =>
                    this.setState({ page: 1, per_page: size }, this.getAttrList),
            },
        };

        return (
            <Modal
                title="选择商品属性参数"
                width={1050}
                visible={visible}
                destroyOnClose={true}
                onOk={() => this.handleClickModalBtn('0')}
                onCancel={() => this.handleClickModalBtn('1')}
            >
                <Row type="flex" justify="space-between" align="middle">
                    <Col>
                        <Form ref={'form'} layout="inline">
                            <Form.Item label="属性编码">
                                <Input
                                    placeholder="请输入"
                                    value={form.code}
                                    onChange={({ target }) =>
                                        this.handleChangeFormItem('code', target.value)
                                    }
                                    onPressEnter={() => this.getAttrList()}
                                />
                            </Form.Item>
                            <Form.Item label="属性名称">
                                <Input
                                    placeholder="请输入"
                                    value={form.name}
                                    onChange={({ target }) =>
                                        this.handleChangeFormItem('name', target.value)
                                    }
                                    onPressEnter={() => this.getAttrList()}
                                />
                            </Form.Item>
                            <Form.Item label="属性类型">
                                <Select
                                    placeholder="选择选项"
                                    style={{ width: 200 }}
                                    value={form.type}
                                    onChange={(e: string) => this.handleChangeFormItem('type', e)}
                                >
                                    <Option value="OPTION">码表</Option>
                                    <Option value="VARCHAR">文本</Option>
                                </Select>
                            </Form.Item>
                        </Form>
                    </Col>
                    <Col>
                        <Button type="primary" onClick={() => this.handleClickOps('0')}>
                            查询
                        </Button>
                        <Button style={{ marginLeft: 10 }} onClick={() => this.handleClickOps('1')}>
                            重置
                        </Button>
                    </Col>
                </Row>

                <Table {...tableProps} />
            </Modal>
        );
    }
}

export default Dialog;
